import {
  Box
} from "./chunk-3OGHJOJF.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/message/message.tsx
import { forwardRef } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { Slot } from "@radix-ui/react-slot";
import { jsx, jsxs } from "react/jsx-runtime";
var MessageTitle = forwardRef(
  (_a, ref) => {
    var _b = _a, { asChild, className } = _b, rest = __objRest(_b, ["asChild", "className"]);
    const Component = asChild ? Slot : "div";
    return /* @__PURE__ */ jsx(
      Component,
      __spreadValues({
        className: clsx("hds-message__title", className),
        ref
      }, rest)
    );
  }
);
MessageTitle.displayName = "Message.Title";
var MessageDescription = forwardRef(
  (_a, ref) => {
    var _b = _a, { asChild, className } = _b, rest = __objRest(_b, ["asChild", "className"]);
    const Component = asChild ? Slot : "div";
    return /* @__PURE__ */ jsx(
      Component,
      __spreadValues({
        className: clsx("hds-message__description", className),
        ref
      }, rest)
    );
  }
);
MessageDescription.displayName = "Message.Description";
var Message = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, className, variant = "success", icon, iconClassName } = _b, rest = __objRest(_b, ["children", "className", "variant", "icon", "iconClassName"]);
    return /* @__PURE__ */ jsxs(
      Box,
      __spreadProps(__spreadValues({
        className: clsx(`hds-message`, `hds-message--${variant}`, className),
        ref
      }, rest), {
        children: [
          variant === "neutral" && /* @__PURE__ */ jsx("div", { className: clsx("hds-message--neutral__icon", iconClassName), children: icon }),
          children
        ]
      })
    );
  }
);
Message.displayName = "Message";
Message.Title = MessageTitle;
Message.Description = MessageDescription;

export {
  MessageTitle,
  MessageDescription,
  Message
};
//# sourceMappingURL=chunk-BYFBK3J7.mjs.map